module.exports = __webpack_public_path__ + "static/assets/6cfa64a624fd2abf7415cde5ed097746.png";